import { FormControl } from '@angular/forms';
import { IFolder } from '@app-root-interfaces';

export function duplicateFolder(folders: IFolder[]) {
    return (control: FormControl): { [key: string]: any } | null => {
        const value = control.value;
        if (!control.value) {
            return null;
        }
        const matchingFolders = folders.filter((folder) => folder.name.toLowerCase() === value.toLowerCase());
        if (matchingFolders.length === 0) {
            return null;
        }
        return {
            duplicateFolder: { value }
        };
    };
}
